import { render, staticRenderFns } from "./weight_select.vue?vue&type=template&id=a4e41e6c&"
import script from "./weight_select.vue?vue&type=script&lang=js&"
export * from "./weight_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "weight_select.vue"
export default component.exports